import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import { Box, SxProps, Theme } from '@mui/material';
import React, { useState } from 'react';
import { ArrowBtnStyle, titleWrapper } from './styled';

interface CollapsibleFrameProps {
  title: JSX.Element | string;
  children: JSX.Element;
  openByDefault?: boolean;
  sx?: SxProps<Theme>;
}

const CollapsibleFrame: React.FC<CollapsibleFrameProps> = ({
  title,
  children,
  openByDefault,
  sx = {}
}) => {
  const [open, setOpen] = useState(openByDefault ?? false);
  return (
    <Box sx={sx}>
      <Box onClick={() => setOpen(!open)} sx={titleWrapper}>
        {open ?
          <ArrowDropUpIcon className="arrowDropIcon" sx={ArrowBtnStyle} /> :
          <ArrowDropDownIcon className="arrowDropIcon" sx={ArrowBtnStyle} />
        }{title}
      </Box>
      {open && children}
    </Box>
  );
};

export default CollapsibleFrame;
